import { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { NavLink, Link as RouterLink } from 'react-router-dom'
import {
  AppBar as MuiAppbar,
  Box,
  Button,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { ReactComponent as CaretDown } from '../../../assets/icons/caret-down.svg'
import { ReactComponent as CaretUp } from '../../../assets/icons/caret-up.svg'
import { ReactComponent as SignOut } from '../../../assets/icons/sign-out.svg'
import { ReactComponent as TextAlignRight } from '../../../assets/icons/text-align-right.svg'
import { ReactComponent as X } from '../../../assets/icons/x.svg'
import { ReactComponent as User } from '../../../assets/icons/user-circle.svg'

import * as routes from '../../../routes'
import useTranslations from '../../../i18n/useTranslations'

import Logo from '../../../assets/images/ctt-logo.svg'
import Avatar from '../../../ui/components/avatar'

import useStyles from './styles'

const AppBar = ({ userName, email, onLogout, isOpen, onToggleMenu }) => {
  const classes = useStyles()
  const t = useTranslations()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'user-menu' : undefined

  const theme = useTheme()
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <MuiAppbar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: isOpen,
      })}
    >
      <Toolbar className={classes.toolbar}>
        <Button
          className={classes.userButton}
          variant="text"
          endIcon={open ? <CaretUp /> : <CaretDown />}
          onClick={handleClick}
        >
          {/* <Avatar
            className={classes.userAvatar}
            size="smaller"
            userName={userName}
            email={email}
          /> */}
          <User className={classes.userIcon} />
          {t('noun:account')}
        </Button>
        <Menu
          id={id}
          classes={{
            paper: classes.userMenu,
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleClose}>
            <RouterLink to={routes.USER_ZONE.linkTo()}>
              {t('noun:user-zone')}
            </RouterLink>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <RouterLink to={routes.AGENDA.linkTo()}>
              {t('noun:agenda')}
            </RouterLink>
          </MenuItem>
        </Menu>

        {isSmUp ? null : (
          <Link underline="none" component={NavLink} to={routes.HOME.linkTo()}>
            <img src={Logo} alt="" className={classes.logo} />
          </Link>
        )}

        <Box>
          {isSmUp ? (
            <Tooltip
              title={
                <Typography variant="body2">{t('action:logout')}</Typography>
              }
              placement="top-start"
            >
              <IconButton onClick={onLogout} size="large">
                <SignOut />
              </IconButton>
            </Tooltip>
          ) : (
            <IconButton onClick={onToggleMenu} size="large">
              {isOpen ? <X /> : <TextAlignRight />}
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </MuiAppbar>
  )
}

AppBar.propTypes = {
  userName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onLogout: PropTypes.func,
  isOpen: PropTypes.bool,
  onToggleMenu: PropTypes.func,
}

export default AppBar
